module.exports = "/images/demo_cold_probe.png?9e8efc7ce796158d2e374945fe38514a";